import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { BackButton } from '@/components/ui/BackButton/BackButtton';
import { changeCurrentTier } from '@/redux/reducers/lotteryReducer';
import { useAppDispatch } from '@/redux/store';

import { useCurrentLotteryTier } from '../hooks';

import { LotteryNavItem } from './LotteryNavItem/LotteryNavItem';
import { navListConfig } from './config';

interface LotteryNavProps {
  className?: string;
}

const LotteryNav: FC<LotteryNavProps> = ({ className }) => {
  const currentTicketType = useCurrentLotteryTier();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <nav className={cn('w-full flex gap-1', className)}>
      <BackButton onClick={() => navigate(AppRoute.MAIN)} />
      {navListConfig.map((props) => {
        const ticketType = props.ticketType;

        return (
          <LotteryNavItem
            isActive={currentTicketType === props.ticketType}
            key={ticketType}
            {...props}
            onClick={() => dispatch(changeCurrentTier(props.ticketType))}
          />
        );
      })}
    </nav>
  );
};

export { LotteryNav };
